"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _core = require("@material-ui/core");

var _reactRouterDom = require("react-router-dom");

var _Tab = _interopRequireDefault(require("./Tab"));

var _jsxRuntime = require("react/jsx-runtime");

function useRouteMatch(pathname, patterns) {
  for (var i = 0; i < patterns.length; i += 1) {
    var _patterns$i = patterns[i],
        link = _patterns$i.link,
        path = _patterns$i.path;
    var possibleMatch = (0, _reactRouterDom.matchPath)(pathname, path || link);

    if (possibleMatch !== null) {
      return link;
    }
  }

  return null;
}

function Tabs(props) {
  // You need to provide the routes in descendant order.
  // This means that if you have nested routes like:
  // users, users/new, users/edit.
  // Then the order should be ['users/add', 'users/edit', 'users'].
  var _React$useState = _react.default.useState(false),
      _React$useState2 = (0, _slicedToArray2.default)(_React$useState, 2),
      currentTab = _React$useState2[0],
      setCurrentTab = _React$useState2[1];

  var _useLocation = (0, _reactRouterDom.useLocation)(),
      pathname = _useLocation.pathname;

  _react.default.useEffect(function () {
    var nav = useRouteMatch(pathname, props.items);
    setCurrentTab(nav);
  }, [pathname]);

  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_core.Tabs, {
    value: currentTab,
    indicatorColor: "primary",
    textColor: "primary",
    children: props.items.map(_Tab.default)
  });
}

Tabs.propTypes = {
  items: _propTypes.default.arrayOf(_propTypes.default.shape({
    link: _propTypes.default.string.isRequired,
    path: _propTypes.default.string,
    label: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.element]).isRequired
  })).isRequired
};
var _default = Tabs;
exports.default = _default;
//# sourceMappingURL=Tabs.js.map